<section>
    <div class="container-fluid bg-colorgrey">
        <div class="row ml-0 mr-0 mt-3">
            <div class="col-md-12">
                <button class="btn btn-primary">Add Priority Area</button>
            </div>
        </div>
    </div>
</section>